import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=c89c383a"
import script from "./addressList.vue?vue&type=script&lang=js"
export * from "./addressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports